import React from 'react'
import IndividualsMoneyFlowIndexChartOld from "./charts/IndividualsMoneyFlowIndexChart";
import IndividualsCapIndexChartOld from "./charts/IndividualsCapIndexChart";
import MarketCapIndexChart from "./charts/MarketCapIndexChart";
import Box from "../../../components/box/Box";
import Head from "next/head";
import {getBahabinText, getTitleFaIranFinancialMarkets} from "../../../util/DominantUtil";
import MarketLastPercentSpreadIndexChart from "./charts/MarketLastPercentSpreadIndexChart";
import MarketStyle from "./MarketStyle";
import BoxLoader401 from "../../../components/loaders/notAuthenticated/BoxLoader401";
import {isMobile} from "react-device-detect";

export default function Market() {
//    const {authenticated} = useAuthenticated(state => ({authenticated: state.authenticated}))
    const tooltipSteps = [
        {
            target: '.IndividualsMoneyFlowIndexChart',
            content: 'میزان ورود و خروج پول افراد حقیقی',
        },
        {
            target: '.MarketLastPercentSpreadIndexChart',
            content: 'دسته بندی بازار بر اساس "درصد تغییر آخرین قیمت" سهام های کل بازار',
        },
        {
            target: '.IndividualsCapIndexChart',
            content: 'میانگین خرید و فروش اشخاص حقیقی',
        },
        {
            target: '.MarketCapIndexChart',
            content: 'مجموع ارزش کل معاملات روزانه بازار سهام',
        },
    ]

    function notAuthenticated() {
        return <BoxLoader401 showMenu={false} contentHeight={248}/>
    }

    return (
        <Box rwFreeHeight={true} disableHeader={true} loaded={true} height={isMobile ? '1250px' : 'auto'}
             leftBoxClassName={'bg-white'}
             showRW={true}
             linksMap={{
                 'last': 'بازار بورس',
             }}>
            <Head>
                <title>{'بازار بورس در یک نگاه' + getBahabinText()}</title>
            </Head>
            <div style={{margin: '0 auto', width: '98%'}}>
                <div className="row mt-20px pt-10px">
                    <div className="col-md col-sm">
                        <IndividualsMoneyFlowIndexChartOld/>
                    </div>
                    <div className="col-md col-sm">
                        <MarketLastPercentSpreadIndexChart/>
                    </div>
                </div>
                <div className="row mt-20px padding-bottom-10">
                    <div className="col-md col-sm">
                        <IndividualsCapIndexChartOld/>
                    </div>
                    <div className="col-md col-sm">
                        <MarketCapIndexChart/>
                    </div>
                </div>
            </div>
            {/*{getJoyRide(tooltipSteps)}*/}
            <MarketStyle/>
        </Box>
    )
}